var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Info1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKe",
    x1: 24,
    x2: 24,
    y1: -8.57,
    y2: 46.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2fcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#c1f3f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#baccfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKf",
    x1: 24,
    x2: 24,
    y1: -8.85,
    y2: 45.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#effbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#b3f0f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#abc1fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKg",
    x1: 24,
    x2: 24,
    y1: -9.11,
    y2: 45.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecfbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#a5edf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9bb5fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKh",
    x1: 24,
    x2: 24,
    y1: -9.34,
    y2: 44.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eafaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#98ebf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#8caafc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKi",
    x1: 24,
    x2: 24,
    y1: -9.54,
    y2: 44.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7f9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8ae8f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7c9ffc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKj",
    x1: 24,
    x2: 24,
    y1: -9.72,
    y2: 43.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f9fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7ce5f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6d93fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKk",
    x1: 24,
    x2: 24,
    y1: -9.86,
    y2: 43.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1f8fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6ee2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5d88fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKl",
    x1: 24,
    x2: 24,
    y1: -9.98,
    y2: 43.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dff7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#61e0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4e7dfb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKm",
    x1: 24,
    x2: 24,
    y1: -10.07,
    y2: 42.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcf7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#53ddef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3e71fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKn",
    x1: 24,
    x2: 24,
    y1: -10.13,
    y2: 42.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9f6fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#45daee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2f66fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKa",
    x1: 24,
    x2: 24,
    y1: 20.64,
    y2: 35.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8fdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2fbff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKo",
    x1: 24,
    x2: 24,
    y1: 20.79,
    y2: 35.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6fcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8faff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKb",
    x1: 24,
    x2: 24,
    y1: 20.95,
    y2: 35.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3fcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cff9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKp",
    x1: 24,
    x2: 24,
    y1: 21.12,
    y2: 35.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1fcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5f8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKc",
    x1: 24,
    x2: 24,
    y1: 21.3,
    y2: 35.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#effbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbf6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKq",
    x1: 24,
    x2: 24,
    y1: 21.49,
    y2: 35.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2f5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKd",
    x1: 24,
    x2: 24,
    y1: 21.68,
    y2: 35.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eafafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8f4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKr",
    x1: 24,
    x2: 24,
    y1: 14.22,
    y2: 19.68,
    xlinkHref: "#pFaafpLAFjH5Cp_70ZidKa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKs",
    x1: 24,
    x2: 24,
    y1: 14.19,
    y2: 19.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6fdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcfaff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKt",
    x1: 24,
    x2: 24,
    y1: 14.19,
    y2: 19.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5fcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5f9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKu",
    x1: 24,
    x2: 24,
    y1: 14.23,
    y2: 19.6,
    xlinkHref: "#pFaafpLAFjH5Cp_70ZidKb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKv",
    x1: 24,
    x2: 24,
    y1: 14.29,
    y2: 19.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2fcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8f8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKw",
    x1: 24,
    x2: 24,
    y1: 14.39,
    y2: 19.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0fbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2f7ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKx",
    x1: 24,
    x2: 24,
    y1: 14.51,
    y2: 19.29,
    xlinkHref: "#pFaafpLAFjH5Cp_70ZidKc"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKy",
    x1: 24,
    x2: 24,
    y1: 14.67,
    y2: 19.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edfbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5f6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKz",
    x1: 24,
    x2: 24,
    y1: 14.86,
    y2: 18.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecfafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aef5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pFaafpLAFjH5Cp_70ZidKA",
    x1: 24,
    x2: 24,
    y1: 15.08,
    y2: 18.75,
    xlinkHref: "#pFaafpLAFjH5Cp_70ZidKd"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKe)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19.67,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKf)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19.33,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKg)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKh)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18.67,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKi)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18.33,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKj)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKk)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17.67,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKl)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17.33,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKm)"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKn)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#pFaafpLAFjH5Cp_70ZidKa)",
    d: "m24,35.47c-1.1,0-2-.9-2-2v-9.91c0-1.1.9-2,2-2s2,.9,2,2v9.91c0,1.1-.9,2-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pFaafpLAFjH5Cp_70ZidKo)",
    d: "m24,35.22c-.97,0-1.75-.78-1.75-1.75v-9.91c0-.97.78-1.75,1.75-1.75s1.75.78,1.75,1.75v9.91c0,.97-.78,1.75-1.75,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pFaafpLAFjH5Cp_70ZidKb)",
    d: "m24,34.97c-.83,0-1.5-.67-1.5-1.5v-9.91c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v9.91c0,.83-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pFaafpLAFjH5Cp_70ZidKp)",
    d: "m24,34.72c-.69,0-1.25-.56-1.25-1.25v-9.91c0-.69.56-1.25,1.25-1.25s1.25.56,1.25,1.25v9.91c0,.69-.56,1.25-1.25,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pFaafpLAFjH5Cp_70ZidKc)",
    d: "m24,34.47c-.55,0-1-.45-1-1v-9.91c0-.55.45-1,1-1s1,.45,1,1v9.91c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pFaafpLAFjH5Cp_70ZidKq)",
    d: "m24,34.22c-.41,0-.75-.34-.75-.75v-9.91c0-.41.34-.75.75-.75s.75.34.75.75v9.91c0,.41-.34.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pFaafpLAFjH5Cp_70ZidKd)",
    d: "m24,33.97c-.28,0-.5-.22-.5-.5v-9.91c0-.28.22-.5.5-.5s.5.22.5.5v9.91c0,.28-.22.5-.5.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17.04,
    r: 2.51,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKr)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17.04,
    r: 2.34,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKs)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17.04,
    r: 2.17,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKt)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17.04,
    r: 2.01,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKu)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17.04,
    r: 1.84,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKv)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17.04,
    r: 1.67,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKw)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17.04,
    r: 1.5,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKx)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17.04,
    r: 1.34,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKy)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17.04,
    r: 1.17,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKz)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17.04,
    r: 1,
    fill: "url(#pFaafpLAFjH5Cp_70ZidKA)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Info1);
export default __webpack_public_path__ + "static/media/icons8-info (1).524795e2428c1a90766165a885f51679.svg";
export { ForwardRef as ReactComponent };